export default __webpack_public_path__ + "static/media/2.c773b8d8.jpeg";